module.exports = __webpack_public_path__ + "img/occlusal.fd3e3454.png";